import React, { useEffect, Suspense, lazy } from 'react';
import { AlertBarLP3, HeroLP3 } from './components/TopSectionsLP3';
import { ScrollReveal } from './components/Overlays';
import { initPixel, trackEvent } from './utils/pixel';
// Lazy load all below-fold sections
const LazySalesLetterSection = lazy(() => import('./components/TopSectionsLP3').then(m => ({
  default: m.SalesLetterSection
})));
const LazyPainGallerySection = lazy(() => import('./components/TopSectionsLP3').then(m => ({
  default: m.PainGallerySection
})));
const LazyWhatYouGetSection = lazy(() => import('./components/MiddleSectionsLP3').then(m => ({
  default: m.WhatYouGetSection
})));
const LazyBonusSectionLP3 = lazy(() => import('./components/MiddleSectionsLP3').then(m => ({
  default: m.BonusSectionLP3
})));
const LazyDynamicPricingSection = lazy(() => import('./components/MiddleSectionsLP3').then(m => ({
  default: m.DynamicPricingSection
})));
const LazyTestimonialMasonrySection = lazy(() => import('./components/MiddleSectionsLP3').then(m => ({
  default: m.TestimonialMasonrySection
})));
// Reuse existing bottom sections
const LazyOrderBumpsSection = lazy(() => import('./components/BottomSections').then(m => ({
  default: m.OrderBumpsSection
})));
const LazyGuaranteeSection = lazy(() => import('./components/BottomSections').then(m => ({
  default: m.GuaranteeSection
})));
const LazyFAQSection = lazy(() => import('./components/BottomSections').then(m => ({
  default: m.FAQSection
})));
const LazyFinalCTASection = lazy(() => import('./components/BottomSections').then(m => ({
  default: m.FinalCTASection
})));
const LazyFooterSection = lazy(() => import('./components/BottomSections').then(m => ({
  default: m.FooterSection
})));
const LazySocialProofToast = lazy(() => import('./components/Overlays').then(m => ({
  default: m.SocialProofToast
})));
export function App3() {
  useEffect(() => {
    initPixel();
    trackEvent('PageView', {
      page: 'LP3_MedicalFear'
    });
  }, []);
  useEffect(() => {
    const handleContextMenu = (e: MouseEvent) => e.preventDefault();
    const handleKeyDown = (e: KeyboardEvent) => {
      if (e.key === 'F12' || e.ctrlKey && e.key === 'u') {
        e.preventDefault();
      }
    };
    document.addEventListener('contextmenu', handleContextMenu);
    document.addEventListener('keydown', handleKeyDown);
    return () => {
      document.removeEventListener('contextmenu', handleContextMenu);
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, []);
  return <div className="min-h-screen bg-[#FEFCF8] antialiased" data-id="element-52">
      {/* Spacer for fixed alert bar */}
      <div className="h-[36px] sm:h-[40px]" data-id="element-53" />
      <AlertBarLP3 data-id="element-54" />

      <main data-id="element-55">
        {/* Hero — above fold, no lazy */}
        <HeroLP3 data-id="element-56" />

        <Suspense fallback={null} data-id="element-57">
          {/* Sales Letter — story-driven pain section */}
          <ScrollReveal data-id="element-58">
            <LazySalesLetterSection data-id="element-59" />
          </ScrollReveal>

          {/* Pain Photo Gallery — uploaded images */}
          <ScrollReveal data-id="element-60">
            <LazyPainGallerySection data-id="element-61" />
          </ScrollReveal>

          {/* What You Get Stack */}
          <ScrollReveal data-id="element-62">
            <LazyWhatYouGetSection data-id="element-63" />
          </ScrollReveal>

          {/* Bonus Section — gold premium */}
          <ScrollReveal data-id="element-64">
            <LazyBonusSectionLP3 data-id="element-65" />
          </ScrollReveal>

          {/* Dynamic Pricing Offer */}
          <ScrollReveal data-id="element-66">
            <LazyDynamicPricingSection data-id="element-67" />
          </ScrollReveal>

          {/* Order Bumps (reused) */}
          <ScrollReveal data-id="element-68">
            <LazyOrderBumpsSection data-id="element-69" />
          </ScrollReveal>

          {/* Guarantee (reused) */}
          <ScrollReveal data-id="element-70">
            <LazyGuaranteeSection data-id="element-71" />
          </ScrollReveal>

          {/* Testimonials — masonry + WhatsApp */}
          <ScrollReveal data-id="element-72">
            <LazyTestimonialMasonrySection data-id="element-73" />
          </ScrollReveal>

          {/* FAQ (reused) */}
          <ScrollReveal data-id="element-74">
            <LazyFAQSection data-id="element-75" />
          </ScrollReveal>

          {/* Final CTA (reused) */}
          <ScrollReveal data-id="element-76">
            <LazyFinalCTASection data-id="element-77" />
          </ScrollReveal>
        </Suspense>
      </main>

      <Suspense fallback={null} data-id="element-78">
        <LazyFooterSection data-id="element-79" />
        <LazySocialProofToast data-id="element-80" />
      </Suspense>
    </div>;
}